import { useMemo } from 'react';
import useSelector from '~/store/useSelector';
import { getEventPayload } from './selectors';
import useConfirmAfterLogin from './useConfirmAfterLogin';
import useConfirmBeforeLogin from './useConfirmBeforeLogin';
import useLogInAndStartPurchase from './useLogInAndStartPurchase';
import useShowPartnerModal from './useShowPartnerModal';
import useStartPurchase from './useStartPurchase';

function useGetStarted(stockNumber: number): () => void {
  const eventPayload = useSelector(getEventPayload);
  const confirmAfterLogin = useConfirmAfterLogin();
  const confirmBeforeLogin = useConfirmBeforeLogin();
  const logInAndStartPurchase = useLogInAndStartPurchase(eventPayload);
  const showPartnerModal = useShowPartnerModal();
  const startPurchase = useStartPurchase(
    `/purchase/dashboard?stock-number=${stockNumber}`,
    eventPayload
  );

  return useMemo(
    () =>
      showPartnerModal(
        confirmBeforeLogin(
          logInAndStartPurchase(confirmAfterLogin(startPurchase), startPurchase)
        )
      ),
    [
      confirmAfterLogin,
      confirmBeforeLogin,
      logInAndStartPurchase,
      showPartnerModal,
      startPurchase
    ]
  );
}

export default useGetStarted;
